import { useState } from 'react';
import toast from 'react-hot-toast';

import TituloSessao from '../componentes/TituloSessao';
import TelaInformativa from './TelaInformativa';
import InputDataMesSemLabel from '../componentes/InputDataMesSemLabel';
import { CONSTANTES } from '../config/constantes'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { servReciboEnvioIndicadoresMes, servDownloadFilePorFilename } from '../servicos/servicosEmRotasPrivadas/download';
import { servPostIndicadorLote } from '../servicos/servicosEmRotasPrivadas/indicador';

function InformarIndicadoresPlanilha() {

    console.log('### Iniciando InformarIndicadoresPanilha ###');

    const [arquivo, setArquivo] = useState(null);
    const [mesReferencia, setMesReferencia] = useState(null);
    const [exibirTelaInformativa, setExibeTelaInformativa] = useState(false)
    const [erros, setErros] = useState(false)
    const [show, setShow] = useState(false);

    async function handlerSubmit(event) {

        event.preventDefault();
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        formData.append('mesReferencia', mesReferencia);

        try {

            const response = await servPostIndicadorLote(formData);
            if (response.status === 201) setExibeTelaInformativa(true)
            
            try {
                await servReciboEnvioIndicadoresMes(mesReferencia)
            } catch (error) {
                console.error(error);
            }

        } catch (error) {
            setArquivo(null)
            if (error?.response?.data?.codigoErro === 6002) {
                setShow(true)
                setErros(error.response.data.erros)
            }
            else {
                console.error(error);
                toast.error(error.message);
            }
        }

    }

    const handleClose = () => setShow(false);

    const handleFileChange = (e) => {
        setArquivo(e.target.files[0]); // só pega o primeiro arquivo (caso não seja múltiplo)
        e.target.value = null // tive que fazer isso pq ao tentar subir o arquivo de novo,
        // por ter o mesmo nome, era tido como mesmo arquivo, mesmo tendo seu conteudo atualizado
    };

    if (exibirTelaInformativa) {
        return <TelaInformativa cabecalho='Indicadores cadastrados com sucesso!'
            mensagem='Clique no botão abaixo para retornar à tela de cadastro de indicadores'
            pathRedirect={null}
            buttonMessage='Voltar'
            urlExterna={false} />;
    }

    console.log(arquivo);

    return (
        <div className='container col-12 col-md-3 p-3'>
            <TituloSessao titulo='Informar Indicadores por Planilha' barraDecorativa={false} centralizaTitulo={true} />
            <form className='d-flex flex-column gap-3' onSubmit={handlerSubmit}>
                <div className='d-flex flex-column div-com-borda p-3 gap-3'>
                    <div>
                        <p className="m-0">
                            # <a
                                href="#"
                                onClick={() => servDownloadFilePorFilename(CONSTANTES.DOWNLOAD_PLANILHA_ENVIO_INDICADORES)}
                                className="pe-auto"
                            >
                                Clique aqui
                            </a> para baixar a planilha padrão #
                        </p>
                    </div>
                    <div>
                        {arquivo ? (
                            <div>
                                <p>Arquivo selecionado: <strong>{arquivo.name}</strong></p>
                                <button type="button"
                                    className="btn btn-secondary w-25"
                                    onClick={() => { setArquivo(null) }}>
                                    LIMPAR
                                </button>
                            </div>
                        ) : (
                            <div>
                                <label htmlFor='planilha-indicadores' >Planilha <strong>padrão</strong> com os indicadores</label>
                                <input className='form-control form-control-sm' onChange={handleFileChange} type='file' id='planilha-indicadores' accept='.xlsx' />
                            </div>
                        )}

                    </div>
                    <div>
                        <label htmlFor='mes-competencia'>Mês Competência</label>
                        <InputDataMesSemLabel dataFim='false' setData={setMesReferencia} id='mes-competencia' />
                    </div>
                </div>

                <button className='btn btn-primary'>ENVIAR</button>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Erro ao Informar Indicadores</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {erros && erros.map((erro, index) => (
                            <table className="table">
                                <thead>
                                    <tr key={index}>
                                        <th scope="col">Linha: {erro.linha}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {erro.erros.map((erroLinha) => (
                                        <tr>
                                            <td>{erroLinha}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            FECHAR
                        </Button>
                    </Modal.Footer>
                </Modal>

            </form>


        </div>
    );
}

export default InformarIndicadoresPlanilha
